import React from 'react';

import { useFavoriteButtons } from '../Personalization/Favorite/FavoriteButtonsContext';
import BrochurePage from '../BrochurePage/BrochurePage';

// Footer copy specific to the Personalized Interactive Brochure.
const PIB_FOOTER_MESSAGE = (
  <>
    Your Personalized Interactive Brochure is brought to you by
    {' '}
    <span>YOUR</span>
    TOUR, a sales enablement tool by THE VECTRE.
  </>
);

// Map the PIB endpoint response into the shape BrochurePageHeader expects.
const getPibHeaderData = (data) => {
  const { resident, community, salesCounselor } = data || {};

  return {
    community,
    names: resident?.names,
    createdDate: resident?.createdDate,
    changedDate: resident?.changedDate,
    message: resident?.message,
    salesCounselor,
    uuid: resident?.uuid,
    // Include favorite IDs for backwards compatibility
    favoriteResidences: resident?.favoriteResidenceIds || [],
    favoriteAmenities: resident?.favoriteAmenityIds || [],
    favoriteFloorPlans: resident?.favoriteFloorPlanIds || [],
    favoriteMedia: resident?.favoriteMediaIds || [],
    mapResidencesFavorites: resident?.mapResidencesFavorites,
    mapFavorites: resident?.mapFavorites,
  };
};

// Map the PIB endpoint response into BrochurePageContent props.
const getPibContentProps = (data, params) => {
  const { community, favorites } = data || {};

  return {
    communitySlug: params.communitySlug,
    resourcesData: community?.resources,
    amenitiesServicesHTML: community?.amenitiesServicesHTML,
    aboutTitle: community?.aboutTitle,
    buckets: community?.buckets,
    initialFavoriteData: getPibHeaderData(data),
    // Pass the full favorites data from the optimized endpoint
    favoritesData: favorites,
  };
};

const getPibDocumentTitle = (data) => {
  const name = data?.community?.name;
  return `${name ? `${name} |` : ''} My YourTour`;
};

// Drupal serves a brochure only to a request that carries the slug and title
// from the prospect's own link (TheVectre/drupal_your_tour#1381), so an nid
// alone no longer opens one. Both go as the route has them: Drupal normalises
// the title, and doing it here too would let the two rules drift apart.
export const getPibApiParams = ({ communitySlug, sanitizedTitle }) => ({
  slug: communitySlug,
  title: sanitizedTitle,
});

const PibPage = () => {
  // Set favorites for map context
  const { setFavorites, setResidenceFavorites } = useFavoriteButtons();

  const handleDataLoaded = (data) => {
    // Set favorite IDs for map context
    if (data?.resident) {
      setFavorites(data.resident.mapFavorites);
      setResidenceFavorites(data.resident.mapResidencesFavorites);
    }
  };

  return (
    <BrochurePage
      apiPath="pib_page"
      getApiParams={getPibApiParams}
      getDocumentTitle={getPibDocumentTitle}
      getHeaderData={getPibHeaderData}
      getContentProps={getPibContentProps}
      onDataLoaded={handleDataLoaded}
      footerMessage={PIB_FOOTER_MESSAGE}
    />
  );
};

export default PibPage;
